module.exports = __webpack_public_path__ + "img/btn1.17e53486.jpeg";